export default {
    STATUS: {
        LOADING: 'loading',
        SUCCESS: 'success',
        FAIL: 'fail'
    }
};
